import actions from '@/core/store/ata/acompanhamento/actions'
import state from '@/core/store/ata/acompanhamento/state'

export default {
	actions,
	state,
}
